/**
 * サブスクリプションプラン価格定数
 *
 * SSOT: .claude/config/business-rules.yml (RED RULE - 変更禁止)
 * これらの価格は StripeのPriceIDと1:1で対応し、変更には
 * Stripe管理画面での設定変更が必須です。
 */

export const PLAN_PRICES = {
  light: { monthly: 19800, annual: 217800 },
  standard: { monthly: 39800, annual: 437800 },
  premium: { monthly: 79800, annual: 877800 },
} as const;

export const PLAN_LABELS: Record<string, string> = {
  light: 'ライトプラン',
  standard: 'スタンダードプラン',
  premium: 'プレミアムプラン',
};

export type PlanId = keyof typeof PLAN_PRICES;
export type BillingCycle = 'monthly' | 'annual';

/**
 * 価格を日本円形式でフォーマット
 */
export function formatPrice(price: number): string {
  return `¥${price.toLocaleString('ja-JP')}`;
}

/**
 * プランIDと課金サイクルから価格を取得
 */
export function getPlanPrice(planId: string, billingCycle: BillingCycle): number | null {
  const normalizedPlanId = planId.toLowerCase() as PlanId;
  const planPrices = PLAN_PRICES[normalizedPlanId];
  if (!planPrices) return null;
  return planPrices[billingCycle];
}

/**
 * 価格から課金サイクルの日本語表記を取得
 */
export function getBillingCycleLabel(billingCycle: BillingCycle): string {
  return billingCycle === 'monthly' ? '月額' : '年額';
}
